import React from 'react';

import { FormTooltip } from 'app/components/FormTooltip';
import { CarRegistrationNumberReadonlyControlProps } from './CarRegistrationNumberReadonlyControl.interfaces';
import { useStyles } from './CarRegistrationNumberReadonlyControl.styles';

export default function CarRegistrationNumberReadonlyControl({
  input: { value: inputValue },
  tooltip,
}: CarRegistrationNumberReadonlyControlProps) {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.plate}>
        <span className={classes.euroband} />
        <span className={classes.value}>{inputValue || ''}</span>
      </div>
      {tooltip && <FormTooltip content={tooltip} className={classes.tooltip} />}
    </div>
  );
}
